import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";

const getHiddenorDeletedSteps = async ({ testStepNumbers, testCaseId }) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No User details found in localStorage");

  const user = JSON.parse(userDetails);

  const response = await axios.post(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=getHiddenorDeletedSteps&companyid=${user.companyid}&tcid=${testCaseId}`,
    { testStepNumbers },
  );
  return response.data;
};

const useGetHiddenOrDeletedStepsMutation = () => {
  return useMutation({
    mutationFn: getHiddenorDeletedSteps,
  });
};

export default useGetHiddenOrDeletedStepsMutation;
